<template>
    <div class="dialog-wrapper" ref="dialog">
        <transition name="fade">
            <div class="dialog-mask" v-if="show"></div>
        </transition>
        <!-- new case -->
        <transition name="slide">
            <div class="dialog" v-if="type == 'dialog'&&show">
                <span class="icon close-btn" @click="dialogClose">&#xe931;</span>
                <div class="dialog-title">{{i18n(title)}}</div>
                <span class="tip">{{ i18n(dialogTip[errorType]) || "" }}</span>
                <div class="input" :class="{ error: error }">
                    <input
                        type="text"
                        :placeholder="i18n('dialog.casename')"
                        v-model="dialogInput"
                        v-focus="focus"
                        @keyup.enter="returnInput"
                    />
                </div>
                <div class="btn">
                    <button class="cancel" @click="dialogClose">{{i18n('dialog.cancel')}}</button>
                    <button
                        class="confirm"
                        :class="{disabled:error}"
                        @click="returnInput"
                    >{{i18n('dialog.ok')}}</button>
                </div>
            </div>

            <!-- confirm -->
            <div class="confirm-dialog" v-else-if="type == 'confirm'&&show">
                <span class="icon close-btn" @click="confirmClose">&#xe931;</span>
                <div class="dialog-title">{{i18n(title)}}</div>
                <div class="info">{{i18nConfirmInfo}}</div>
                <div class="btn">
                    <button class="warn" @click="confirm">{{i18n('dialog.delete')}}</button>
                    <button class="confirm" @click="confirmClose">{{i18n('dialog.cancel')}}</button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import i18n from "@/i18n";
import store from "@/store";
export default {
    props: {
        type: {
            type: String,
            default: "dialog"
        },
        name: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "dialog.newcase"
        }
    },
    data() {
        return {
            show: false,
            dialogTip: ["dialog.tip1", "dialog.tip2", "dialog.tip3"],
            tips: [
                "*Please use 8 or more characters",
                "*The old password is incorrect",
                "*The new passwords do not match."
            ],

            dialogInput: "",
            error: false,
            errorType: 0,
            focus: true
        };
    },
    computed: {
        fileName() {
            let value = this.name;
            if (value.length > 14) {
                value = `"${value.slice(0, 14)}..."`;
            } else if (value !== "") {
                value = `"${value}"`;
            } else {
                value = i18n.t("dialog.selected-items");
            }
            return value;
        },
        i18nConfirmInfo() {
            let info = i18n.t("dialog.confirm");
            let new_info =
                info.split("?")[0] + this.fileName + "?" + info.split("?")[1];

            return new_info;
        }
    },
    methods: {
        i18n(val) {
            return i18n.t(val);
        },
        inputFocus(index) {
            this.nowFocus = index;
        },
        inputBlur() {
            this.nowFocus = -1;
        },
        close() {
            this.show = false;
            setTimeout(() => {
                console.log("remove");
                if (this.$refs.dialog) {
                    console.log("removeChild");
                    document.body.removeChild(this.$refs.dialog);
                }
            }, 300);
        },
        checkInput() {
            if (this.dialogInput.trim() == "") {
                this.error = true;
                this.errorType = 0;
            } else if (this.dialogInput.length > 32) {
                this.error = true;
                this.errorType = 1;
            } else {
                let allCase = store.state["allCases"];
                this.error = allCase.some(v => {
                    return v["caseName"] == this.dialogInput.trim();
                });
                this.errorType = 2;
            }
        },
        returnInput() {
            this.checkInput();

            if (!this.error) {
                this.$fire.$emit(
                    "caseName",
                    this.dialogInput,
                    new Date().getTime()
                );
                this.close();
            }
        },
        dialogClose() {
            this.$fire.$emit("caseName", false);
            this.close();
        },
        confirmClose() {
            this.$fire.$emit("confirm", false);
            this.close();
        },
        confirm() {
            this.$fire.$emit("confirm", true);
            this.close();
        },
        /**
         * listen keypress event to confirm
         */
        keyConfirm(e) {
            if (e.code == "Enter") {
                this.confirm();
                document.removeEventListener("keyup", this.keyConfirm);
            }
        }
    },
    watch: {
        dialogInput(val) {
            if (val.trim() == "") {
                this.error = true;
            } else if (val.length > 32) {
                this.error = true;
                this.errorType = 1;
            } else {
                this.errorType = 0;
                this.error = false;
            }
        },
        pwdInput: {
            handler(val) {
                let old_pwd = val[0].input;
                let new_pwd = val[1].input;
                let new_pwd_repeat = val[2].input;
            },
            deep: true
        }
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.focus();
            }
        }
    },
    mounted() {
        this.show = true;
        if (this.type == "confirm") {
            document.addEventListener("keyup", this.keyConfirm);
        }
    }
};
</script>

<style lang="scss" scoped>
.dialog-wrapper {
    @include flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 500;
    .dialog-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.3);
    }
    .dialog,
    .confirm-dialog {
        @include flex;
        position: relative;
        justify-content: flex-start;
        flex-direction: column;
        width: 400px;
        background: rgba(254, 254, 254, 1);
        box-shadow: 2px 3px 30px -10px rgba(13, 36, 60, 1);
        border-radius: 4px;
        padding: 20px 30px;
        z-index: 500;
        .dialog-title {
            font-size: 22px;
            font-weight: 400;
            color: $dark-purple;
        }
        .tip {
            display: inline-block;
            height: 20px;
            margin-top: 5px;
            font-size: 14px;
            color: $warning;
            align-self: flex-start;
        }
        .info {
            padding: 5px 0;
            align-self: stretch;
            color: $font-base-color;
            line-height: 20px;
            font-size: 16px;
            margin-top: 10px;
        }
        .input {
            height: 30px;
            align-self: stretch;
            position: relative;
            padding: 5px 0;
            margin-top: 12px;
            &.error {
                &::after {
                    background-color: $warning;
                    animation: error 150ms;
                }
            }
            input {
                font-size: 18px;
                outline: none;
                border: none;
                margin: 0 5px;
                width: 100%;
                &::placeholder {
                    color: $border-color;
                }
            }
            &::after {
                @include after;
                height: 2px;
                width: 100%;
                bottom: 0;
                background-color: #e1e3f3;
            }
        }
        .btn {
            @include flex;
            padding-top: 20px;
            align-self: stretch;
            margin-top: auto;
            flex-direction: row;
            justify-content: flex-end;
            button {
                @include flex;
                font-size: 18px;
                height: 36px;
                width: 90px;
                border-radius: 4px;
                border-color: transparent;
                margin-left: 10px;
                transition: all 150ms;
                outline: none;
                cursor: pointer;
            }
            .cancel {
                color: $dark-purple;
                background-color: transparent;
                &:hover {
                    background-color: #e1e3e7;
                }
                &:active {
                    background-color: $light-purple;
                    color: $base-color;
                }
            }
            .warn {
                color: $warning;
                &:hover {
                    background-color: $warning-hover;
                }
                &:active {
                    background-color: $warning-active;
                }
            }
            .confirm {
                background-color: $dark-purple;
                color: $base-color;
                &.disabled {
                    background-color: $border-color;
                    &:hover,
                    &:active {
                        background-color: $border-color;
                    }
                }
                &:hover {
                    background-color: $light-purple;
                }
                &:active {
                    background-color: $graph-color;
                }
            }
        }
    }
    // .account-setting {
    //   position: relative;
    //   width: 400px;
    //   padding: 30px;
    //   background: rgba(254, 254, 254, 1);
    //   box-shadow: 2px 3px 30px -10px rgba(13, 36, 60, 1);
    //   border-radius: 15px;
    //   z-index: 500;
    //   transition: all 200ms;
    //   .info {
    //     & > div {
    //       @include flex;
    //       justify-content: flex-start;
    //       & > span {
    //         font-size: 18px;
    //         line-height: 30px;
    //         &:first-child {
    //           position: relative;
    //           color: $dark-purple;
    //           flex-basis: 105px;
    //           margin-right: 20px;
    //           flex-shrink: 0;
    //           &::after {
    //             @include after;
    //             content: ":";
    //             right: 0;
    //             top: 50%;
    //             transform: translateY(-50%);
    //           }
    //         }
    //         &:last-child {
    //           color: $font-base-color;
    //         }
    //       }
    //     }
    //   }
    //   .change-pwd {
    //     @include flex;
    //     align-self: stretch;
    //     height: 40px;
    //     border: 1px solid $border-color;
    //     margin-top: 20px;
    //     border-radius: 20px;
    //     color: $light-purple;
    //     cursor: pointer;
    //     transition: border 200ms;
    //     &:hover {
    //       border-color: $light-purple;
    //     }
    //     &.active {
    //       background-color: $light-purple;
    //       border-color: $light-purple;
    //       color: $base-color;
    //     }
    //   }
    //   .change-pwd-space {
    //     margin-top: 20px;
    //     align-self: stretch;
    //     .title {
    //       font-size: 18px;
    //       text-align: center;
    //       margin: 0 20px;
    //       border-top: 2px solid $border-color;
    //       color: $dark-purple;
    //       line-height: 60px;
    //     }
    //     .pwd-input {
    //       width: 100%;
    //       height: 34px;
    //       border: 1px solid $border-color;
    //       border-radius: 12px;
    //       padding-left: 15px;
    //       margin-bottom: 10px;
    //       transition: all 300ms;
    //       &.focus {
    //         border-color: $light-purple;
    //       }
    //       &.error {
    //         border-color: $warning;
    //       }
    //       & > input {
    //         font-size: 16px;
    //         line-height: 30px;
    //         border: none;
    //         outline: none;
    //         width: 90%;
    //         &::placeholder {
    //           color: $border-color;
    //         }
    //       }
    //     }
    //     .tip {
    //       position: relative;
    //       top: -10px;
    //       color: $border-color;
    //       font-size: 13px;
    //       padding-left: 15px;
    //       line-height: 15px;
    //     }
    //   }
    //   .change-pwd-btn {
    //     button:first-child {
    //       background-color: transparent;
    //       border-color: transparent;
    //       font-weight: 400;
    //       color: $light-purple;
    //       &:hover {
    //         background-color: #e1e3f3;
    //       }
    //     }
    //   }
    //   .btn {
    //     @include flex;
    //     margin-top: 30px;
    //     align-self: stretch;
    //     justify-content: flex-end;
    //     button {
    //       @include flex;
    //       color: $base-color;
    //       outline: none;
    //       font-size: 18px;
    //       font-weight: 500;
    //       margin: 0 10px;
    //       width: 90px;
    //       height: 36px;
    //       border: none;
    //       background: $light-purple;
    //       border-radius: 20px;
    //       cursor: pointer;
    //       transition: background-color 150ms;
    //       &:hover {
    //         background-color: #4d5498;
    //       }
    //       &.disabled {
    //         background-color: #d8d8d8;
    //         color: $base-color;
    //       }
    //     }
    //   }
    // }
    span.close-btn {
        color: $font-base-color;
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
        &:hover {
            color: $light-purple;
        }
    }
}

@keyframes error {
    0% {
        transform: scaleX(0);
    }
    100% {
        transform: scaleX(1);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 300ms;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 300ms;
    transform: tranlateY(0);
}
.slide-enter,
.slide-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}
</style>



// WEBPACK FOOTER //
// src/components/wsDialog.vue